export default "__VITE_ASSET__DoDaWKV5__"